export enum FamilyMemberFields {
  AddressSameAsPrimaryMemberResidenceAddress = 'addressSameAsPrimaryMemberResidenceAddress',
  ResidenceAddress = 'residenceAddress',
}
